import cc from 'classcat';
import { useState } from 'react';
import { DateTime } from 'luxon';
import { IActivityLogState } from '..';
import { Img } from '../../Common/Img';
import { Calendar } from '../../Common';

interface SingleDateRangePickerProps {
    values: IActivityLogState;
    setFieldValue: (field: string, value: any) => void;
}

const SingleDateRangePicker = ({ values, setFieldValue }: SingleDateRangePickerProps) => {
    const [displayDate, setDisplayDate] = useState(DateTime.now().startOf('day'));
    const [displayCalendar, setDisplayCalendar] = useState(false);

    const { startDate, endDate } = values.dates;

    const changeDate = (selectedDate: DateTime) => {
        const dates = { startDate, endDate };

        if (dates.startDate && dates.endDate) {
            return setFieldValue('dates', { startDate: selectedDate, endDate: null });
        }

        if (dates.startDate && !dates.endDate) {
            return selectedDate <= dates.startDate ? setFieldValue('dates.startDate', selectedDate) : setFieldValue('dates.endDate', selectedDate);
        }

        return setFieldValue('dates.startDate', selectedDate);
    };

    return (
        <div className="date-range-picker">
            <button
                type="button"
                className={cc(['date-range-picker__button', { 'date-range-picker__button--opened': displayCalendar }])}
                onClick={() => setDisplayCalendar(prev => !prev)}
            >
                {displayCalendar ? <Img src="/svg/calendar-white.svg" alt="Calendar" /> : <Img src="/svg/calendar-blue.svg" alt="Calendar" />}
            </button>
            {displayCalendar && (
                <>
                    <div className="event-bubbling-mask" onClick={() => setDisplayCalendar(false)}></div>
                    <Calendar
                        enablePastDays={true}
                        displayDate={displayDate}
                        changeMonth={setDisplayDate}
                        onClick={changeDate}
                        activeModal
                        startDate={values.dates.startDate}
                        endDate={values.dates.endDate}
                        modalAlignment={'right'}
                    />
                </>
            )}
        </div>
    );
};

export default SingleDateRangePicker;
